export default __webpack_public_path__ + "static/media/yogatimeTwitter-600x314.c0dcd135.jpg";